<div class="dashboard-container">
  <div class="dashboard-header">
    <h1 class="gradient-text">ТРЦ Ocean Plaza - Статистика Паркування</h1>
    <p class="subtitle">Моніторинг трафіку та заповненості в реальному часі</p>
  </div>

  <!-- Статистичні картки -->
  <div class="stats-grid">
    @for (card of statCards; track card.title) {
      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-icon-wrapper" [class.trend-up]="card.trend === 'up'" [class.trend-down]="card.trend === 'down'">
            <mat-icon>{{card.icon}}</mat-icon>
          </div>
          <div class="stat-content">
            <span class="stat-title">{{card.title}}</span>
            <h2 class="stat-value">{{card.value}}</h2>
            <span class="stat-change" [class.positive]="card.trend === 'up'" [class.negative]="card.trend === 'down'">
              <mat-icon>{{card.trend === 'up' ? 'trending_up' : 'trending_down'}}</mat-icon>
              {{card.change}}
            </span>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>

  <!-- Графіки -->
  <div class="charts-section">
    <div class="chart-row">
      <mat-card class="chart-card full-width">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>schedule</mat-icon>
            Трафік по годинах (сьогодні)
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="chart-container">
            <canvas baseChart
              [data]="hourlyChartData"
              [options]="hourlyChartOptions"
              type="line">
            </canvas>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="chart-row">
      <mat-card class="chart-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>calendar_today</mat-icon>
            Трафік по днях тижня
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="chart-container">
            <canvas baseChart
              [data]="dailyChartData"
              [options]="dailyChartOptions"
              type="bar">
            </canvas>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="chart-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>location_on</mat-icon>
            Трафік по точках в'їзду/виїзду
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <table mat-table [dataSource]="locationTraffic" class="location-table">
            <ng-container matColumnDef="location">
              <th mat-header-cell *matHeaderCellDef>Точка</th>
              <td mat-cell *matCellDef="let element">{{element.location}}</td>
            </ng-container>

            <ng-container matColumnDef="entries">
              <th mat-header-cell *matHeaderCellDef>В'їзд</th>
              <td mat-cell *matCellDef="let element">
                <span class="entry-badge">{{element.entries || '-'}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="exits">
              <th mat-header-cell *matHeaderCellDef>Виїзд</th>
              <td mat-cell *matCellDef="let element">
                <span class="exit-badge">{{element.exits || '-'}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>Всього</th>
              <td mat-cell *matCellDef="let element">
                <strong>{{getTotal(element)}}</strong>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsLocation"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsLocation;"></tr>
          </table>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Детальна таблиця по годинах -->
  <mat-card class="data-table-card">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>table_chart</mat-icon>
        Детальна статистика по годинах
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="hourlyTraffic" class="hourly-table">
        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef>Година</th>
          <td mat-cell *matCellDef="let element">{{element.time}}</td>
        </ng-container>

        <ng-container matColumnDef="entries">
          <th mat-header-cell *matHeaderCellDef>В'їзд</th>
          <td mat-cell *matCellDef="let element">
            <span class="entry-badge">{{element.entries}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="exits">
          <th mat-header-cell *matHeaderCellDef>Виїзд</th>
          <td mat-cell *matCellDef="let element">
            <span class="exit-badge">{{element.exits}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef>Всього</th>
          <td mat-cell *matCellDef="let element">
            <mat-chip class="total-chip">{{getTotal(element)}}</mat-chip>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-card-content>
  </mat-card>
</div>
